import React from "react";
import Mockups from '../assets/Mockups.png'
import { Outlet, useNavigate } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export default function AuthLayout() {
  let navigate = useNavigate();
  return (
    <div className="flex">
      <div className="w-2/4 bg-black min-h-screen hidden lg:block">

        <ArrowRight size={32}    className="cursor-pointer text-white absolute top-7 left-5 rotate-180"   onClick={() => navigate('/')} />
       <div className="flex justify-center items-center h-full ">
       <img src={Mockups} alt="" className="" /> 
       </div>
      </div>
      <div className="lg:w-2/4 w-screen flex justify-center items-center min-h-screen bg-[#222222] py-6">
        <ArrowRight
          size={45}
          className="lg:hidden block text-white absolute top-7 left-5 rotate-180"
          onClick={() => navigate('/')}
        />
        <Outlet /> {/* This will render the nested routes */}
      </div>
    </div>
  );
}
